import { render, staticRenderFns } from "./FirstEditor.vue?vue&type=template&id=49e86950"
import script from "./FirstEditor.vue?vue&type=script&lang=js"
export * from "./FirstEditor.vue?vue&type=script&lang=js"
import style0 from "./FirstEditor.vue?vue&type=style&index=0&id=49e86950&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports